module.exports = __webpack_public_path__ + "static/media/search01.a179d9d5.png";